<template>
  <div class="events-pricing bg-2 rounded-16 p-4">
    <snow-select
      v-model="form.currency"
      class="mb-6"
      label="Moeda base"
      :options="[{ id: 'BRL', name: 'Real Brasileiro' }]"
    />

    <payment-methods v-model="form.payment_methods_ids" isEvent class="mb-6" />

    <template v-if="isParceledBillet">
      <snow-select
        v-model="form.billet_installments"
        :options="billetInstallmentOptions"
        class="my-5"
        label="Parcelamento *"
        :rules="rules.billetInstallments"
      />

      <snow-switch
        v-model="form.billet_apply_interest"
        label="Taxa sobre parcelamento de boletos"
      />

      <span class="fs-14 text-dark-40">
        Em uma compra parcelada por boletos, serão aplicados juros sobre as
        parcelas.
      </span>
    </template>

    <template v-else-if="isCardSale">
      <snow-select
        v-model="form.installments"
        :options="installmentOptions"
        class="my-5"
        label="Parcelamento *"
        :rules="rules.installments"
      />

      <snow-switch
        v-model="form.is_tax_to_producer"
        label="Taxas para o produtor"
      />

      <div class="fs-14 text-dark-40 pb-5">
        Em uma compra parcelada, o produtor pagará as taxas do parcelamento
      </div>
    </template>

    <snow-select
      v-model="form.warranty"
      class="mb-2"
      label="Prazo para solicitação de reembolso *"
      :options="warranties"
    />

    <span class="fs-14 text-dark-40">
      Este é também o prazo que o cliente tem para pedir reembolso do evento. No
      Brasil, o prazo mínimo é de 7 dias e na União Europeia, de 15 dias.
    </span>
  </div>
</template>
<script>
import SnowSwitch from "@/components/snow-ui/SnowSwitch.vue";
import { required } from "@/functions/validation.js";
import { mapState } from "vuex";
import PaymentMethods from "../PaymentMethods.vue";
export default {
  components: { PaymentMethods, SnowSwitch },
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      cb: [],
      rules: {
        billetInstallments: [required()],
        installments: [required()]
      }
    };
  },
  computed: {
    ...mapState("product", ["warranties"]),
    isParceledBillet() {
      return !!this.form.payment_methods_ids.find(p => p == 6);
    },
    isCardSale() {
      return !!this.form.payment_methods_ids.find(p => [1, 3, 34].includes(p));
    },
    installmentOptions() {
      let options = [];
      for (let i = 1; i <= 12; i++) {
        options.push({ id: i, name: `Em até ${i} x` });
      }
      return options;
    },
    billetInstallmentOptions() {
      return Array(12)
        .fill()
        .map((_, i) => ({
          id: i + 1,
          name: `Até ${i + 1} parcela${i ? "s" : ""}`
        }));
    }
  }
};
</script>
